export const API_GLOBAL_NOTIFICATION_INDEX = 'API_GLOBAL_NOTIFICATION_INDEX'

export const fetchGlobalNotification = () => ({ type: API_GLOBAL_NOTIFICATION_INDEX })
